import Provider from 'react-redux/es/components/Provider';
import App from './components/App';
import { store } from './store';
import { InternalServerError } from 'shared/components';
import {BugsnagConfigProvider, ErrorBoundary} from '@dnhb/functional-component';

const apiKey = process.env.BUGSNAG_JS_API_KEY;

const Root = () => (
  <BugsnagConfigProvider bugsnagApiKey={apiKey}>
    <ErrorBoundary fallbackComponent={InternalServerError}>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </BugsnagConfigProvider>
);

export default Root;
